<template>
  <el-dialog class="order-add-dialog"
             :visible.sync="data.visible"
             title="划拨云豆"
             width="620px"
             center
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :close-delay="false">
    <div class="pv-content">
      <el-form :model="data" :rules="rules" ref="ruleForm" label-width="200px">
        <el-form-item label="用户登录账号">
          <el-input v-model="data.account" name="account" placeholder="输入后点击右侧查询" style="width: 80%">
            <el-button slot="append" icon="el-icon-search" @click="handleQuery()" :loading="data.loading">查询</el-button>
          </el-input>
        </el-form-item>
        <div v-if="data.user.nickname">
          <el-form-item label="账号名称">
            {{ data.user.nickname }}
          </el-form-item>
          <el-form-item label="user id" hidden>
            <el-input v-model="data.user.user_id" name="user_id" class="cs-input">
            </el-input>
          </el-form-item>
          <el-form-item label="购买数量">
            <el-input-number v-model="data.num" :step="1" :min="0" name="num" style="width: 60%"></el-input-number>
          </el-form-item>
          <el-form-item label="购买总价（元）">
            <el-input-number v-model="data.total_price" :step="0.01" :min="0" name="total_price"
                             placeholder="不在前端显示" style="width: 60%"></el-input-number>
          </el-form-item>
          <el-form-item label="备注">
            <el-col :span="16" style="width: 80%">
              <el-input type="textarea" v-model="data.note" name="note" placeholder="不在前端显示"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="data.loading" @click="handleOK">购买</el-button>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="账号名称">
            <span v-if="data.account" style="color: #ff4d51">没有查询到用户</span>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      rules: {
        account: [
          {required: true, message: '请输入套餐标题', trigger: 'blur'},
          {min: 3, max: 18, message: '长度在 3 到 18 个字符', trigger: 'blur'}
        ],
        product_id: [
          {required: true, message: '请输入副标题', trigger: 'blur'},
          {min: 3, max: 18, message: '长度在 3 到 18 个字符', trigger: 'blur'}
        ]
      }
    }
  },
  props: {
    data: {
      visible: false,
      loading: false,
      title: '',
      user: {
        nickname: ''
      }
    }
  },
  methods: {
    handleQuery (e) {
      this.$emit('query', e)
    },
    handleOK (e) {
      let that = this
      that.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          console.log('error submit!!')
          return false
        }
        that.$emit('ok', e)
      })
    }
  }
}
</script>

<style>
.order-add-dialog .el-dialog {
  background: #e5e9f2;
}

.order-add-dialog .el-dialog__header {
  padding: 0 20px 0px 20px;
  height: 50px;
  background-color: #fff;
}

.order-add-dialog .el-dialog__title {
  color: #0C0C0C;
  line-height: 50px;
}

.order-add-dialog .el-dialog__body {
  padding: 20px;
  width: 500px;
}

.order-add-dialog .pv-content {
  padding-top: 5px;
  width: 620px;
  min-height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.order-add-dialog .pv-content .el-form-item.divider {
  border-bottom: 1px solid #348fe2;
}

.order-add-dialog .pv-content .el-form-item__label {
  color: #0C0C0C;
  font-weight: bold;
}

.order-add-dialog .pv-content .el-input__inner {
  border: 1px solid gainsboro;
  color: black;
}

.order-add-dialog .pv-content .el-input-number__decrease, .el-input-number__increase {
  color: black;
}

.order-add-dialog .pv-content .el-textarea__inner {
  border: 1px solid gainsboro;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderAddDialog.vue